import util from '@/common/util';
import { mapState as rootMapState } from 'pinia';
import { usePageStore } from '@/store';
import { mapState, mapActions } from '@/store/helpers';
import {
    UPDATE_CONDITION,
    CENTER_DEL_CONDITION,
    CENTER_DEL_KEYWORD,
    CENTER_DEL_INPUT_BOX,
    SET_TRANSLATED_PROPS,
    CENTER_DEL_SUGGESTION,
    REMOVE_KEYWORD_MUTATION,
    MAP_CHANGE_MUTATION
} from '../_store/types';
import {
    generateKeywordTag,
    generateSelectTag,
    generateInputBoxTag,
    generateTextTag,
    generateCheckboxTag,
    generateSuggestionTag,
    generateTagWithoutConfig
} from '@/common/search-tag-list';
import dispatchCondition from '../_mixins/dispatch-condition';
// import { translate } from '../translateSelectOptions';
const searchTag = {
    mixins: [dispatchCondition()],
    props: ['exclude'],
    data: function() {
        return {
            translatedProps: {}
        };
    },
    computed: {
        ...mapState({
            keywords: store => store.keywords
        }),
        //  displayed label
        filteredTagList() {
            let list = [];
            this.allConditions.forEach(cond => {
                // filter does not exist   or  filter middle include cond.dn
                if (
                    !this.filter ||
                    (!this.exclude && this.filter.indexOf(cond.dn) !== -1) ||
                    (this.exclude && this.filter.indexOf(cond.dn) === -1)
                ) {
                    cond.labels && cond.labels.forEach((label, index) => {
                        if (!label) {
                            return;
                        }
                        let data = {
                            dn: cond.dn,
                            label: label
                        };
                        if (cond.dn === 'key') {
                            let value = cond.values[index].split(':');
                            data.keyword = value.slice(1).join(':');
                            data.keywordType = value[0];
                        }
                        list.push(data);
                    });
                }
            });
            //  to sort
            if (this.conditionSort) {
                return list.sort((a, b) => {
                    return (
                        this.conditionSort.indexOf(a.dn) -
                        this.conditionSort.indexOf(b.dn)
                    );
                });
            }
            return list;
        }
    },
    methods: {
        ...mapActions({
            updateConditionMutation: UPDATE_CONDITION,
            removeKeywordMutation: REMOVE_KEYWORD_MUTATION,
            mapChangeMutation: MAP_CHANGE_MUTATION
        }),
        removeTag(item) {
            // TODO emit
            if (item.dn === 'key') {
                const oldValue = util.deepClone(this.keywords);
                this.removeKeywordMutation({
                    keyword: item.keyword,
                    keywordType: item.keywordType
                });
                this.dispatchConditions({
                    init: false,
                    kee: 'key',
                    value: util.deepClone(this.keywords),
                    oldValue
                });
            } else if (item.dn === 'mapPath') {
                this.mapChangeMutation({
                    mapPath: null
                });
                this.dispatchConditions({
                    init: false,
                    kee: 'mapPath',
                    value: null
                    // oldValue
                });
            } else if (item.dn === 'mapRadius') {
                this.mapChangeMutation({
                    mapRadius: null
                });
                this.dispatchConditions({
                    init: false,
                    kee: 'mapRadius',
                    value: null
                });
            } else if (item.dn === 'mapSearch') {
                this.mapChangeMutation({
                    mapSearch: false
                });
                this.dispatchConditions({
                    init: false,
                    kee: 'mapSearch',
                    value: false
                    // oldValue
                });
            } else {
                let cond = this.conditions[item.dn];
                if (cond) {
                    switch (cond.type) {
                    case 'select': {
                        if (cond.multiple) {
                            let labels = util.cloneData(cond.labels);
                            let index = -1;
                            labels.forEach((label, idx) => {
                                if (label === item.label) {
                                    index = idx; 
                                }
                            });
                            if (index === -1) {
                                return; 
                            }
                            labels.splice(index, 1);
                            let values = cond.value.split(cond.split);
                            values.splice(index, 1);
                            let value = values.join(cond.split);
                            this.dispatchConditions({
                                init: false,
                                kee: cond.kee,
                                value,
                                oldValue:
                                        this.conditions[cond.kee] &&
                                        this.conditions[cond.kee].value
                            });
                            this.updateConditionMutation({
                                kee: cond.kee,
                                value,
                                labels: labels,
                                inMore: this.conditions[cond.kee]?.inMore
                            });
                        } else {
                            this.dispatchConditions({
                                init: false,
                                kee: cond.kee,
                                value: '',
                                oldValue:
                                        this.conditions[cond.kee] &&
                                        this.conditions[cond.kee].value
                            });
                            this.updateConditionMutation({
                                kee: cond.kee,
                                value: '',
                                labels: [],
                                inMore: this.conditions[cond.kee]?.inMore
                            });
                        }
                        break;
                    }
                    case 'range': {
                        let labels = util.cloneData(cond.labels);
                        let index = -1;
                        labels.forEach((label, idx) => {
                            if (label === item.label) {
                                index = idx; 
                            }
                        });
                        if (index === -1) {
                            return; 
                        }
                        labels[index] = '';
                        let values = cond.value.split(cond.split);
                        values[index] = '';
                        let value = values.some(v => !!v)
                            ? values.join(cond.split)
                            : '';
                        this.dispatchConditions({
                            init: false,
                            kee: cond.kee,
                            value,
                            oldValue:
                                    this.conditions[cond.kee] &&
                                    this.conditions[cond.kee].value
                        });
                        this.updateConditionMutation({
                            kee: cond.kee,
                            value,
                            labels: labels,
                            inMore: this.conditions[cond.kee]?.inMore
                        });
                        break;
                    }
                    default: {
                        this.dispatchConditions({
                            init: false,
                            kee: cond.kee,
                            value: '',
                            oldValue:
                                    this.conditions[cond.kee] &&
                                    this.conditions[cond.kee].value
                        });
                        this.updateConditionMutation({
                            kee: cond.kee,
                            value: '',
                            labels: [],
                            inMore: this.conditions[cond.kee]?.inMore
                        });
                        break;
                    }
                    }
                }
            }
        },
        // translate(list) {
        //     try {
        //         translateOptions(list).then(data => {
        //             list.forEach((value, index) => {
        //                 Object.assign(value, data[index]);
        //             })
        //         }).catch(err =>{
        //             console.log(err);
        //         });
        //     } catch (error) {
        //         console.log(error);
        //     }
        // },
        resetSearch() {
            this.filteredTagList.forEach(tag => this.removeTag(tag));
        },
        clearPolygonBoundray() {
            this.filteredTagList.forEach(tag => {
                if (['mapPath', 'mapRadius', 'mapSearch', 'key'].includes(tag.dn)) {
                    this.removeTag(tag)
                }
            });
        }
    }
};
const searchTagCenter = {
    mixins: [dispatchCondition()],
    props: ['exclude'],
    computed: {
        ...rootMapState(usePageStore, {
            page: store => store.page,
            currencySymbol: store => store.currency.symbol,
            currencyAbbr: store => store.currency.abbr,
            baseCurrency: store => store.baseCurrency,
            currencyRate: store => store.currencyRate
        }),
        isCurCurrencyEqualBaseCurrency() {
            //  Determine whether the currently selected currency is equal to the base currency
            return this.currencyAbbr === this.baseCurrency;
        },
        ...mapState({
            keywords: store => store.keywords,
            translatedProps: store => store.translatedProps
        }),
        ...mapState([
            'searchConfigMap'
        ]),
        //  displayed label
        filteredTagList() {
            let list = [];
            this.allConditions.forEach(cond => {
                // filter does not exist   or  filter middle include cond.dn
                if (
                    !this.filter ||
                    (!this.exclude && this.filter.indexOf(cond.dn) !== -1) ||
                    (this.exclude && this.filter.indexOf(cond.dn) === -1)
                ) {
                    if (cond.dn === 'key') {
                        cond.labels && cond.labels.forEach((label, index) => {
                            if (!label) {
                                return;
                            }
                            let data = {
                                dn: cond.dn,
                                label
                            };

                            let value = cond.values[index].split(':');
                            data.keyword = value.slice(1).join(':');
                            data.keywordType = value[0];

                            list.push(data);
                        });
                    } else if (
                        ['mapSearch', 'mapPath', 'mapRadius'].includes(cond.dn)
                    ) {
                        cond.labels && cond.labels.forEach((label, index) => {
                            if (!label) {
                                return;
                            }
                            // if (cond.dn === 'mapSearch' && this.forCMS) {
                            //     label = 'Custom Boundary';
                            // }
                            let data = {
                                dn: cond.dn,
                                label
                            };
                            list.push(data);
                        });
                    } else {
                        const name = cond.dn,
                            value = cond.values;
                        const config = this.searchConfigMap[name];
                        let tempList = [];
                        if (config) {
                            const inputType = config.inputType;
                            switch (inputType) {
                            case 'singleSelect':
                            case 'multiSelect':
                                tempList.push(
                                    ...generateSelectTag(
                                        value,
                                        name,
                                        config
                                    )
                                );
                                break;
                            case 'keyWord':
                                tempList.push(
                                    ...generateKeywordTag(
                                        value,
                                        name,
                                        config
                                    )
                                );
                                break;
                            case 'inputBox':
                                tempList.push(
                                    ...generateInputBoxTag(
                                        value,
                                        name,
                                        config,
                                        this.currencyRate,
                                        this.currencySymbol,
                                        this.isCurCurrencyEqualBaseCurrency
                                    )
                                );
                                break;
                            case 'text':
                                tempList.push(
                                    ...generateTextTag(value, name, config)
                                );
                                break;
                            case 'checkBox':
                                tempList.push(
                                    ...generateCheckboxTag(
                                        value,
                                        name,
                                        config
                                    )
                                );

                                break;
                            case 'suggestion':
                                tempList.push(
                                    ...generateSuggestionTag.call(
                                        this,
                                        value,
                                        name,
                                        config
                                    )
                                );
                                break;
                            default:
                                break;
                            }
                        } else {
                            tempList.push(
                                ...generateTagWithoutConfig.call(this, value, name)
                            );
                        }
                        tempList = tempList.map(o => {
                            return {
                                dn: o.paramsKey,
                                inputType: o.inputType,
                                delTag: o.delTag,
                                label: o.title,
                                keyword: o.keyword, // key
                                keywordType: o.keywordType
                            };
                        });
                        list.push(...tempList);
                    }
                }
            });
            //  to sort
            if (this.conditionSort) {
                return list.sort((a, b) => {
                    return (
                        this.conditionSort.indexOf(a.dn) -
                        this.conditionSort.indexOf(b.dn)
                    );
                });
            }
            return list;
        }
    },
    methods: {
        ...mapActions({
            removeKeywordMutation: REMOVE_KEYWORD_MUTATION,
            mapChangeMutation: MAP_CHANGE_MUTATION,
            centerDelCondition: CENTER_DEL_CONDITION,
            centerDelKeyword: CENTER_DEL_KEYWORD,
            centerDelInputBox: CENTER_DEL_INPUT_BOX,
            setTranslatedProps: SET_TRANSLATED_PROPS,
            centerDelSuggestion: CENTER_DEL_SUGGESTION
        }),
        // translate(config) {
        //     translate({
        //         name: config.name,
        //         options: config.options,
        //         setTranslatedProps: this.setTranslatedProps,
        //         translatedProps: this.translatedProps,
        //         callback: data => {
        //             config.options.forEach((value, index) => {
        //                 Object.assign(value, data[index]);
        //             });
        //         }
        //     });
        // },
        removeTag(item) {
            if (item.dn === 'key') {
                const oldValue = util.deepClone(this.keywords);
                this.removeKeywordMutation({
                    keyword: item.keyword,
                    keywordType: item.keywordType
                });
                this.dispatchConditions({
                    init: false,
                    kee: 'key',
                    value: util.deepClone(this.keywords),
                    oldValue
                });
            } else if (item.dn === 'mapPath') {
                this.mapChangeMutation({
                    mapPath: null
                });
                this.dispatchConditions({
                    init: false,
                    kee: 'mapPath',
                    value: null
                });
            } else if (item.dn === 'mapRadius') {
                this.mapChangeMutation({
                    mapRadius: null
                });
                this.dispatchConditions({
                    init: false,
                    kee: 'mapRadius',
                    value: null
                });
            } else if (item.dn === 'mapSearch') {
                this.mapChangeMutation({
                    mapSearch: false
                });
                this.dispatchConditions({
                    init: false,
                    kee: 'mapSearch',
                    value: false
                    // oldValue
                });
            } else {
                const oldValue = util.deepClone(this.conditions[item.dn]);
                if (item.delTag === -1) {
                    // delete the field
                    this.centerDelCondition(item.dn);
                } else {
                    switch (item.inputType) {
                    case 'keyWord':
                        this.centerDelKeyword({
                            name: item.dn,
                            delTag: item.delTag
                        });
                        break;
                    case 'inputBox':
                        this.centerDelInputBox({
                            name: item.dn,
                            delTag: item.delTag
                        });
                        break;
                    case 'suggestion':
                        this.centerDelSuggestion({
                            name: item.dn,
                            delTag: item.delTag
                        });
                        break;
                    default:
                        break;
                    }
                }
                const newValue = util.deepClone(this.conditions[item.dn]);
                this.dispatchConditions({
                    init: false,
                    kee: item.dn,
                    value: newValue,
                    oldValue
                });
            }
        },
        resetSearch() {
            this.filteredTagList.forEach(tag => this.removeTag(tag));
        },
        clearPolygonBoundray() {
            this.filteredTagList.forEach(tag => {
                if (['mapPath', 'mapRadius', 'mapSearch', 'key'].includes(tag.dn)) {
                    this.removeTag(tag)
                }
            });
        }
    }
};

export { searchTag, searchTagCenter };
